module.exports = __webpack_public_path__ + "img/wybm.04669de7.png";